import { FormBuilder } from '@formio/react';

import FormViewer from './FormViewer';

const FORM_OPTIONS = {
  builder: {
    basic: false,
    customBasic: {
      title: 'Basic',
      default: true,
      weight: 0,
      components: {
        textfield: true,
        textarea: true,
        number: true,
        checkbox: true,
        selectboxes: true,
        select: true,
        radio: true,
        button: true,
      },
    },
    data: false,
    layout: false,
    premium: false,
    searchEnabled: false,
  },
  noDefaultSubmitButton: true,
};

const FormEditor = ({ onChangeSchema, selectedForm, schema }) => {
  return (
    <div className="form-builder-container col-sm-12">
      <div className="row">
        <div className="col-sm-6 half-width">
          <div className="panel-title">Form Builder</div>
          <div className="form-builder">
            <FormBuilder
              id="formBuilder"
              options={FORM_OPTIONS}
              initialForm={selectedForm.form}
              onChange={onChangeSchema}
            />
          </div>
        </div>
        <div className="col-sm-6 half-width left-border">
          <div className="panel-title">Preview</div>
          <FormViewer
            form={schema || selectedForm?.form}
            options={FORM_OPTIONS}
            classes="preview"
          ></FormViewer>
        </div>
      </div>
    </div>
  );
};
export default FormEditor;
